export default __webpack_public_path__ + "static/media/pia-dandiya.dedcdb04.png";